import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import NRSuperIndexAndValue from '../../../NRSuperIndexAndValue/NRSuperIndexAndValue';
import { getSeverityColor } from '../../../../utils/palette.utils';
import { capitalizeFirstLetter } from '../../../../utils/utils';
import { CREATE_JIRA_TICKET_LABELS } from './createJiraTicket.constants';

function NRCreateVulnerabilityJiraTicketSummary({ vulnerabilityData = {}, cveDetails = {} }) {
  const theme = useTheme();

  const severityLabel = useMemo(() => {
    const score =
      vulnerabilityData.cvssScore != null && !isNaN(Number(vulnerabilityData.cvssScore))
        ? Number(vulnerabilityData.cvssScore).toFixed(1)
        : null;
    const severityText = vulnerabilityData.severity ? capitalizeFirstLetter(vulnerabilityData.severity) : '';
    return [score, severityText].filter(Boolean).join(' ');
  }, [vulnerabilityData.cvssScore, vulnerabilityData.severity]);

  const epssLabel = useMemo(() => {
    const epssScore = vulnerabilityData.epssScore;
    const epssText =
      epssScore != null && !isNaN(Number(epssScore)) ? `${(Number(epssScore) * 100).toFixed(1)}%` : null;
    const maturity = vulnerabilityData.maturity || cveDetails?.exploit?.maturity || '';
    return [epssText, maturity ? capitalizeFirstLetter(maturity) : ''].filter(Boolean).join(' ');
  }, [cveDetails?.exploit?.maturity, vulnerabilityData.epssScore, vulnerabilityData.maturity]);

  const componentLabel = useMemo(() => {
    const { name, version } = vulnerabilityData;
    return [name, version].filter(Boolean).join(' ');
  }, [vulnerabilityData.name, vulnerabilityData.version]);

  const severityColor = getSeverityColor(vulnerabilityData.severity, theme);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        gap: theme.spacing(2),
        alignItems: 'start',
        px: theme.spacing(2),
        py: theme.spacing(1.5),
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(1),
        backgroundColor: theme.palette.background.paper
      }}
    >
      <NRSuperIndexAndValue
        superIndex={CREATE_JIRA_TICKET_LABELS.VULNERABILITY}
        value={vulnerabilityData.cve || '—'}
        valueColor={theme.palette.text.primary}
        extraSx={{ minWidth: 0 }}
      />
      <NRSuperIndexAndValue
        superIndex={CREATE_JIRA_TICKET_LABELS.SEVERITY}
        value={severityLabel || '—'}
        valueColor={theme.palette.text.primary}
        avatar={
          <Box
            aria-hidden
            sx={{
              width: 3,
              height: 16,
              borderRadius: 1,
              backgroundColor: severityColor,
              flexShrink: 0
            }}
          />
        }
        extraSx={{ minWidth: 0 }}
      />
      <NRSuperIndexAndValue
        superIndex={CREATE_JIRA_TICKET_LABELS.EPSS}
        value={epssLabel || '—'}
        valueColor={theme.palette.text.primary}
        extraSx={{ minWidth: 0 }}
      />
      <NRSuperIndexAndValue
        superIndex={CREATE_JIRA_TICKET_LABELS.COMPONENT}
        value={componentLabel || '—'}
        valueColor={theme.palette.text.primary}
        extraSx={{ minWidth: 0 }}
      />
    </Box>
  );
}

export default NRCreateVulnerabilityJiraTicketSummary;
